var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "evenodd",
    d: "M6,20 C6.553,20 7,19.553 7,19 L7,16 C7,15.447 6.553,15 6,15 C5.447,15 5,15.447 5,16 L5,19 C5,19.553 5.447,20 6,20 M23,22 L2,22 L2,1 C2,0.448 1.553,0 1,0 C0.447,0 0,0.448 0,1 L0,23 C0,23.553 0.447,24 1,24 L23,24 C23.553,24 24,23.553 24,23 C24,22.447 23.553,22 23,22 M11,20 C11.553,20 12,19.553 12,19 L12,14 C12,13.447 11.553,13 11,13 C10.447,13 10,13.447 10,14 L10,19 C10,19.553 10.447,20 11,20 M16,20 C16.553,20 17,19.553 17,19 L17,10 C17,9.448 16.553,9 16,9 C15.447,9 15,9.448 15,10 L15,19 C15,19.553 15.447,20 16,20 M20,19 L20,1 C20,0.448 20.447,0 21,0 C21.553,0 22,0.448 22,1 L22,19 C22,19.553 21.553,20 21,20 C20.447,20 20,19.553 20,19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackChart);
export default __webpack_public_path__ + "static/media/black-chart.ee1bb77ac3266b9cbad88ecca009debb.svg";
export { ForwardRef as ReactComponent };